import rateAxiosInstance from "./RateAxiosInstance";

const getVideoRating = (body) => {
  return rateAxiosInstance.post(
    "/likes_video/average-user-vote-video",
    body
  );
};
const postVideoRating = (body) => {
  return rateAxiosInstance.post(
    "/likes_video/vote-by-user-and-video",
    body
  );
};

export default {
  getVideoRating,
  postVideoRating,
};
